<template lang="pug">
.loading(v-bind:class="{ 'is-open': isOpen, 'is-hide': isHide }" v-if="!isComplete")
  .bar(v-bind:class="{ 'is-active': isBarActive }")
  img.logo-image(src='../assets/logo.png')
</template>

<script>
const preloadIamges = [
  {
    url : require('../assets/top_image_03.png')
  },
  {
    url : require('../assets/top_image_05.png')
  },
  {
    url : require("../assets/top_image_04.png")
  },
  {
    url : require("../assets/top_image_02.png")
  },
  {
    url : require("../assets/logo.png")
  },
  {
    url : require("../assets/header_logo_white.png")
  },
  {
    url : require("../assets/image01.jpg")
  },
  {
    url : require("../assets/image05.jpg")
  },
  {
    url : require("../assets/image03.jpg")
  },
  {
    url : require("../assets/image04.jpg")
  },
  {
    url : require("../assets/image_shampoo_01.jpg")
  }
]

export default {
  data () {
    return {
      isHide: false,
      isOpen: false,
      isBarActive: false,
      isComplete: false
    }
  },
  mounted : function(){
    console.log('mounted')
    setTimeout(function(){
      window.scrollTo(0,1);
    }, 1);
    this.Preload()
    this.AnimStart()
  },
  methods: {
    async AnimStart() {
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.isBarActive = true
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.isOpen = true
      await new Promise(resolve => setTimeout(resolve, 1000))
      this.isHide = true

      this.$emit('update-loadingend', true);

      await new Promise(resolve => setTimeout(resolve, 1000))
      this.isComplete = true
    },
    async Preload() {
      preloadIamges.forEach(image => {
        const preImage = new Image()
        if (image.url) {
          console.log(image.url)
          preImage.src = image.url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 100;
  opacity: 1;
  overflow: hidden;
  transition: opacity 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  &.is-hide {
    opacity: 0;
  }
  &.is-open {
    > .bar {
      opacity: 0;
    }
  }
  > .bar {
    width: 0;
    height: 2px;
    background: #fff;
    transition: all .8s cubic-bezier(0.2, 0.8, 0.2, 1);
    &.is-active {
      width: 100%;
    }
  }
}

.logo-image {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 150px;
  opacity: 1;
  transition: opacity .6s cubic-bezier(0.2, 0.2, 0.2, 1);
}

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue